import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import { ERROR_MESSAGES } from "../../../constants/enums";
import { IBusinessPolicyChange } from "./businessPolicyChane.types";
import { makeApiCall } from "../../../helpers/postRequest";
import { IDatatableV2AdvancedSearchFilter } from "../../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { IDataTableV2DateState } from "../../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { uploadTaskFile } from "../../tasks/tasksActions";
import { IInternalLogEntry } from "../../accessLogs/accessLogs.types";

export const FETCH_BUSINESS_POLICY_CHANGE_LIST_PROGRESS =
  "FETCH_BUSINESS_POLICY_CHANGE_LIST_PROGRESS";
export const FETCH_BUSINESS_POLICY_CHANGE_LIST_SUCCESS =
  "FETCH_BUSINESS_POLICY_CHANGE_LIST_SUCCESS";
export const FETCH_BUSINESS_POLICY_CHANGE_LIST_FAILED =
  "FETCH_BUSINESS_POLICY_CHANGE_LIST_FAILED";

export const fetchBusinessPolicyChangeListProgress = () =>
  action(FETCH_BUSINESS_POLICY_CHANGE_LIST_PROGRESS);
export const fetchBusinessPolicyChangeListSuccess = (
  list: IBusinessPolicyChange[],
  totalRecords: number
) =>
  action(FETCH_BUSINESS_POLICY_CHANGE_LIST_SUCCESS, {
    list,
    totalRecords,
  });
export const fetchBusinessPolicyChangeListFailed = () =>
  action(FETCH_BUSINESS_POLICY_CHANGE_LIST_FAILED);

export const fetchBusinessPolicyChangeListAsync =
  (
    customerpolicyId: number,
    status: string,
     searchValue: IDatatableV2AdvancedSearchFilter,
     date: IDataTableV2DateState["dates"],
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchBusinessPolicyChangeListProgress());

      let finalUrl = `/policy/get-policy-business-policy-change-request?customer_policy_id=${customerpolicyId}&from_date=${date.fromDate}&to_date=${date.toDate}`;

      if (status !== undefined && status !== "-1") {
        finalUrl += "&status=" + status;
      }
      if (searchValue.length > 0) {
        finalUrl += `&advanceFilter=${JSON.stringify(searchValue)}`;
      }

      const res = await api.get(finalUrl);
      const data: IBusinessPolicyChange[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchBusinessPolicyChangeListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchBusinessPolicyChangeListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const FETCH_BUSINESS_POLICY_CHANGE_PROGRESS =
  "FETCH_BUSINESS_POLICY_CHANGE_APPLICATION_PROGRESS";
export const FETCH_BUSINESS_POLICY_CHANGE_SUCCESSS =
  "FETCH_BUSINESS_POLICY_CHANGE_APPLICATION_SUCCESSS";
export const FETCH_BUSINESS_POLICY_CHANGE_FAILED =
  "FETCH_BUSINESS_POLICY_CHANGE_APPLICATION_FAILED";

export const fetchBusinessPolicyChangeProgress = () =>
  action(FETCH_BUSINESS_POLICY_CHANGE_PROGRESS);
export const fetchBusinessPolicyChangeSuccess = (
  data: IBusinessPolicyChange
) =>
  action(FETCH_BUSINESS_POLICY_CHANGE_SUCCESSS, { data });
export const fetchBusinessPolicyChangeFailed = (error?: string) =>
  action(FETCH_BUSINESS_POLICY_CHANGE_FAILED, { error });

export const fetchBusinessPolicyChangeAsync =
  (customerPolicyId: number, incrementalNumber: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchBusinessPolicyChangeProgress());
      const res = await api.get(
        `/policy/get-policy-business-policy-change-request?customer_policy_id=${customerPolicyId}&change_request_code=${incrementalNumber}`
      );
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchBusinessPolicyChangeSuccess({ ...data[0] }));
      } else {
        dispatch(
          fetchBusinessPolicyChangeFailed(ERROR_MESSAGES.NO_RECORD_FOUND)
        );
      }
    } catch (err: any) {
      dispatch(fetchBusinessPolicyChangeFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addBusinessPolicyChange =
  (
    data: IBusinessPolicyChange,
        initialData: IBusinessPolicyChange,
                isUpdate: boolean,
    onCallback: (isSuccess: boolean, data?: IBusinessPolicyChange) => void,
    logData?: IInternalLogEntry,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const asPayload = {
         customer_id: data.customer_id,
         policy_type: data.policy_type,
         customer_policy_id: data.customer_policy_id,
         page_name: "Business Policy Change",
      };

      const updateFilesJson = await uploadTaskFile(
        data.attachments as any,
        "POLICY",
        asPayload
      );
    
       const res = await makeApiCall(
                          {
                            url:  "/policy/create-policy-business-policy-change-request",
                            method: "POST",
                            automation: {
                              isUpdate: isUpdate,
                              primaryFieldName: "change_request_code",
                            },
                          },
                          initialData,
                          {
                            ...data,
                            attachments: updateFilesJson,
                          }
                        );
      onCallback(true, res.data.data);
      dispatch(
        showMessage({
          type: "success",
          message: "Policy Changed successfully!",
          displayAs: "snackbar",
        })
      );
      dispatch(fetchBusinessPolicyChangeSuccess(data));
      if (logData) {
        dispatch({ type: "custom/log", logData });
      }
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_BUSINESS_POLICY_CHANGE_STATE =
  "CLEAR_BUSINESS_POLICY_CHANGE_STATE";

export const clearBusinessPolicyChangeState = () =>
  action(CLEAR_BUSINESS_POLICY_CHANGE_STATE);
